// extracted by mini-css-extract-plugin
export default {"header":"_svHo","heading":"PskhA","dialog-select":"JWKRq","spinner":"_sGWU","error":"R2kJk"};